import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './settings.component';
import { SettingsStyleComponent } from './settings-style/settings-style.component';
import { SettingsCacheComponent } from './settings-cache/settings-cache.component';
import { SettingsAnagraficheComponent } from './settings-anagrafiche/settings-anagrafiche.component';
import { SettingsFilesComponent } from './settings-files/settings-files.component';



const routes: Routes = [
    {path: '', component: SettingsComponent, children: [
        { path: '', redirectTo: 'memory', pathMatch: 'full' },
        {
            path: 'memory', component: SettingsCacheComponent,
        },
        {
            path: 'style', component: SettingsStyleComponent,
        },
        {
            path: 'anagrafiche', component: SettingsAnagraficheComponent,
        },
        {
            path: 'files', component: SettingsFilesComponent,
        }
    ] },
    {path: '**', redirectTo: '' },
];



@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class SettingsRoutingModule { }

